import { Id } from "@dgs/core";

export interface IntegrationIndexResource {
	id: Id;
	type: string;
}

export enum DresoField {
	// employee fields
	DEFAULT_LOCALE = "defaultLocale",
	CAREER_START = "careerStart",
	CAREER_START_ADJUSTED = "careerStartAdjusted",
	CONFIDENTIAL_EMAIL = "confidentialEmail",
	DISPLAY_BIRTHDAY = "displayBirthday",
	DOMAIN_ACCOUNT = "domainAccount",
	EMAIL = "email",
	EMPLOYEE_MAGAZINE_TYPE = "employeeMagazineType",
	ENTRY_GROUP = "entryGroup",
	ENTRY_TECHNICAL = "entryTechnical",
	FAX = "fax",
	FIRST_NAME = "firstName",
	GENDER = "gender",
	ID = "id",
	IMPORTED = "imported",
	LAST_WORKING_DAY = "lastWorkingDay",
	LAST_NAME = "lastName",
	LICENSE_PLATE_BUSINESS_CAR = "licensePlateBusinessCar",
	LICENSE_PLATE_PRIVATE_CAR = "licensePlatePrivateCar",
	MOBILE_PHONE = "mobilePhone",
	PERSONNEL_NUMBER = "personnelNumber",
	PHONE = "phone",
	PREFERRED_FIRST_NAME = "preferredFirstName",
	PREFERRED_LAST_NAME = "preferredLastName",
	RESIGNATION = "resignation",
	SALUTATION = "salutation",
	SIGNATURE_ALTERNATIVE_JOB_LEVEL_DE = "signatureAlternativeJobLevelDe",
	SIGNATURE_ALTERNATIVE_JOB_LEVEL_EN = "signatureAlternativeJobLevelEn",
	SIGNATURE_USE_JOB_LEVEL = "signatureUseJobLevel",
	SIGNATURE_USE_JOB_LEVEL_CODE = "signatureUseJobLevelCode",
	SIGNATURE_USE_MOBILE_PHONE = "signatureUseMobilePhone",
	TITLE = "title",
	// employment fields
	ABBREVIATION = "abbreviation",
	ACADEMIC_TITLE = "academicTitle",
	ACTIVE = "active",
	ALLOWED_TO_DISPOSE = "allowedToDispose",
	EMPLOYEE_ID = "employeeId",
	EMPLOYEE_TYPE = "employeeType",
	ENTRY_DATE = "entryDate",
	EXIT_DATE = "exitDate",
	FACTOR = "factor",
	FACTORED_STANDARD_HOURS_PER_MONTH = "factoredStandardHoursPerMonth",
	INTERNAL_SUPPORT = "internalSupport",
	PERSON = "person",
	STANDARD_HOURS_PER_DAY = "standardHoursPerDay",
	STANDARD_HOURS_PER_MONTH = "standardHoursPerMonth",
	STATUS = "status",
	WRITING_HOURS = "writingHours",
}

export interface DresoConfigEntry {
	dresoField: DresoField;
	contactAttributeId: number;
	isReference: boolean;
	isRequired: boolean;
}

export type DresoConfig = DresoConfigEntry[];

export type IntegrationType = "dreso";

export interface IntegrationResource {
	id: Id;
	type: IntegrationType;
	config: DresoConfig;
}

export interface IntegrationCreateRequest {
	type: IntegrationType;
}
